/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function(){

$('.product_gallery .product_gallery_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  adaptiveHeight: true,
  prevArrow: '<div class="prev_arrow"><svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none"><path d="M18.7593 9.34921C18.3998 8.92988 17.7685 8.88132 17.3492 9.24074C16.9299 9.60017 16.8813 10.2315 17.2407 10.6508L18.7593 9.34921ZM30 24L30.7593 24.6508C31.0802 24.2763 31.0802 23.7237 30.7593 23.3492L30 24ZM17.2407 37.3492C16.8813 37.7685 16.9299 38.3998 17.3492 38.7593C17.7685 39.1187 18.3998 39.0701 18.7593 38.6508L17.2407 37.3492ZM17.2407 10.6508L29.2407 24.6508L30.7593 23.3492L18.7593 9.34921L17.2407 10.6508ZM29.2407 23.3492L17.2407 37.3492L18.7593 38.6508L30.7593 24.6508L29.2407 23.3492Z" fill="#999999"/></svg></div>',
  nextArrow: '<div class="prev_next"><svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none"><path d="M18.7593 9.34921C18.3998 8.92988 17.7685 8.88132 17.3492 9.24074C16.9299 9.60017 16.8813 10.2315 17.2407 10.6508L18.7593 9.34921ZM30 24L30.7593 24.6508C31.0802 24.2763 31.0802 23.7237 30.7593 23.3492L30 24ZM17.2407 37.3492C16.8813 37.7685 16.9299 38.3998 17.3492 38.7593C17.7685 39.1187 18.3998 39.0701 18.7593 38.6508L17.2407 37.3492ZM17.2407 10.6508L29.2407 24.6508L30.7593 23.3492L18.7593 9.34921L17.2407 10.6508ZM29.2407 23.3492L17.2407 37.3492L18.7593 38.6508L30.7593 24.6508L29.2407 23.3492Z" fill="#999999"/></svg></div>',
  asNavFor: '.product_gallery .product_gallery_thumb_slider',
   responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: true
      }
    }
     ]
});
$('.product_gallery .product_gallery_thumb_slider').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  asNavFor: '.product_gallery .product_gallery_slider',
  focusOnSelect: true
});

  // var window_width = $( window ).width();
  // if(window_width <= 749){
  //    setTimeout(function () {
  //       $('.card .card__wrapper .img_wrapper .original_img').hide();
  //       $('.card .card__wrapper .hover_img').show();

  //      var video_tag_length = $('.card .card__wrapper video').length;
  //      for(var i = 0; i < video_tag_length; i++){
  //       $('.card .card__wrapper video').get(i).play(); 
  //      }
  //   }, 5000);
  // }
  
  var card = $(".card .card__wrapper");
      $(card).mouseenter(function () {
        if($(this).find('video').length == 1){
        $(this).find('video').get(0).play();
          }

        // if($(this).find('iframe').length == 1){
        //   var videoURL = $(this).find('iframe').prop('src');
        //   videoURL += "&autoplay=1";
        //   $(this).find('iframe').prop('src',videoURL);
        // }
      });
        $(card).mouseleave(function () {
          if($(this).find('video').length == 1){
         $(this).find('video').get(0).pause();
          }
      });

  $('.product_gallery .product_gallery_slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  console.log(nextSlide);
});
  
    $('.product_gallery .product_gallery_slider').on('afterChange', function(event, slick, currentSlide){
     var product_gallery = $(this).find('.slick-current');
    if($(product_gallery).find('video').length == 1){
          $(product_gallery).find('video').get(0).play();
    }
  });
//   $('body').on('click', '.mo-search', function() {
//     $('.mo-search-form').show();
// });
});


  var window_width = $( window ).width();
  if(window_width <= 749){
$.fn.isInViewport = function() {
  
  var elementTop = $(this).offset().top;
  var addelementBottom = elementTop - 300;
  var elementBottom = addelementBottom + $(this).outerHeight();
 
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

// $(window).on('scroll', function() {
//   $('.card .card__wrapper').each(function() {
//       var index_tab = $(this).attr('data-index');
//     if ($(this).isInViewport()) {
//       $('.card__wrapper[data-index="'+ index_tab +'"]').find('.original_img').hide();
//       $('.card__wrapper[data-index="'+ index_tab +'"]').find('.hover_img').show();
//       if($('.card__wrapper[data-index="'+ index_tab +'"]').find('video').length > 0){
//         $('.card__wrapper[data-index="'+ index_tab +'"]').find('video').get(0).play();
//       }
//     } else {
//       $('.card__wrapper[data-index="'+ index_tab +'"]').find('.original_img').show();
//       $('.card__wrapper[data-index="'+ index_tab +'"]').find('.hover_img').hide();
//        if($('.card__wrapper[data-index="'+ index_tab +'"]').find('video').length > 0){
//           $('.card__wrapper[data-index="'+ index_tab +'"]').find('video').get(0).pause();
//        }
//     }
//   });
// });
  }
// function addItemToCart(variant_id, qty) {
//     console.log("clicked cart");
//     data = {
//       "id": variant_id,
//       "quantity": qty
//     }
    
//     jQuery.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: data,
//       dataType: 'json',
//       success: function() {
//         location.reload();
//         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//           bubbles: true  //this code is for prestige theme, is to refresh the cart
//        }));
//       }
//     });
//     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//     	bubbles: true    // same code for prestige theme   
//  	 }));
//   }




function addItemToCart(variant_id, qty) {
    console.log("clicked cart");
    data = {
      "id": variant_id,
      "quantity": qty
    }    
   let formData = {
 'items': [{
  'id': variant_id,
  'quantity': 1
  }]
};
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(response => {
  console.log('------------inn----');
 // this._transitionAddToCartButton.bind(this, n);
  // $.ajax({
  //       type: 'GET',
  //       url: '/cart.js',
  //       cache: false,
  //       dataType: 'json',
  //       success: function(cart) {
  //         // whatever you want to do with the cart obj
  //         console.log("cart.js called=>",cart);
  //       }
  //   });
  return response.json();
})
.catch((error) => {
  console.error('Error:', error);
});
  }
// $(document).ajaxComplete(function() {
//   console.log("fire");
//   CartJS.updateCart();
// });


$(document).ready(function(){

$(".cert-cls").click(function(){  
  $(".main-modal-container").hide();
  $(".content-hidden-def").fadeIn(500); 
  $(".cc-modal-window__content_cert-cls").fadeIn(500); 
});

  $(".cod-check").click(function(){  
  $(".main-modal-container").hide();
  $(".content-hidden-def").fadeIn(500); 
  $(".cc-modal-window__content_cod-cls").fadeIn(500); 
});
  
  
$(".handmade-cls").click(function(){ 
  $(".main-modal-container").hide();
  $(".content-hidden-def").fadeIn(500); 
  $(".cc-modal-window__content-handmade-cls").fadeIn(500);
});
  
$(".shipping-cls").click(function(){
  $(".main-modal-container").hide();
  $(".content-hidden-def").fadeIn(500);  
  $(".cc-modal-window__content-shipping-cls").fadeIn(500);
});
  
$(".deliverytime-cls").click(function(){ 
  $(".main-modal-container").hide();
  $(".content-hidden-def").fadeIn(500);  
   $(".cc-modal-window__content-delivery_time-cls").fadeIn(500);
});
  
$(".sold-cls").click(function(){  
  $(".main-modal-container").hide();
  $(".content-hidden-def").fadeIn(500);
  $(".cc-modal-window__content-sold-cls").fadeIn(500);
});
  
$(".wwship-cls").click(function(){  
  $(".main-modal-container").hide();
  $(".content-hidden-def").fadeIn(500); 
  $(".cc-modal-window__content-wwship-cls").fadeIn(500);
});
 $(".faqs-cls").click(function(){  
  $(".main-modal-container").hide();
  $(".content-hidden-def").fadeIn(500); 
  $(".cc-modal-window__content-faqs-cls").fadeIn(500);
}); 

  $(".non_refundable-cls").click(function(){  
  $(".main-modal-container").hide();
  $(".content-hidden-def").fadeIn(500); 
  $(".cc-modal-window__content-non_refundable-cls").fadeIn(500);
});
$(".gift_wrap-cls").click(function(){  
  $(".main-modal-container").hide();
  $(".content-hidden-def").fadeIn(500); 
  $(".cc-modal-window__content-gift_wrap-cls").fadeIn(500);
});  

$('.cc-modal-window__close').on("click",function(){
	$(".content-hidden-def").css("display", "none");
  
});
  $(".desc-readmore").click(function(){
    $(".product-small-desc").hide();
    $(".product-detailed-desc").show();
    
  });
//   tabs code for product page

      $('.tab-a').click(function(){  
      $(".tab").removeClass('tab-active');
      $(".tab[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
      $(".tab-a").removeClass('active-a');
      $(this).parent().find(".tab-a").addClass('active-a');
     });
   $('.addtovcartvarientout').click(function(){
     alert('Please select the desired variant');
     $(".tab-a").trigger("click");
     });
  $('.mo-search-form').click(function(){
    $(".inner-page-search").hide();
    $(".inner-page-search-show").show();
    });
   $('.view-varient-in-pro').click(function(){
     alert('Please select the desired variant');
     });

  // $('.add-to-cart-coll').click(function(){
  //   var productID = $(this).attr("product-id");
  //   addItemToCart(productID,1);
  // });

  $('.readmore').click(function (event) {
event.preventDefault();
var descriptionFull = document.querySelector('.product-description-full');
descriptionFull.style.display = 'block';
var descriptionShort = document.querySelector('.product-description-short');
descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
event.preventDefault();
var descriptionFull = document.querySelector('.product-description-full');
descriptionFull.style.display = 'none';
var descriptionShort = document.querySelector('.product-description-short');
descriptionShort.style.display = 'block';
 // window.scrollTo({top: 30, behavior: 'smooth'});
});

  $(".varient-col").click(function(){
    var currentVariant = '';
    var priceset = '';
     var proid= $(this).parents('.varient-gee').attr('product-id');
    if(this.checked){
     currentVariant = $(this).attr("gold-variant-id");
      priceset = $(this).attr("gold-variant-price");
    }
    else{
      currentVariant = $(this).attr("silver-variant-id");
      priceset = $(this).attr("silver-variant-price");
    }   
    $('.pro-mainimg-'+proid+ 'img').removeClass('variant-img-active');
    $('.hidden-pro-var').removeClass('variant-img-active');
    $(".prodvariant-img-"+currentVariant).addClass("variant-img-active");
    $('.propriceproid-'+proid).html(priceset);
});
 $(".buy-tog").click(function(){
   $('this').prop('disabled', true);
   let allProducts = []; 
$('input[name="buy_it_together"]:checked').each(function() {
  let obj1 = { id: this.value, quantity: 1 }; 
   allProducts.push(obj1); 
});
   let formData = {
 'items': allProducts
};
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(response => {
  alert('Successfully added to cart.');
  $(".variation-tabs-2 .product__add-to-cart-button").addClass("innerAddtocart");  
  $(".innerAddtocart").trigger("click");  
  //location.reload();
  return response.json();  
})
.catch((error) => {
  console.log('Error:', error);
});
  });
  
});


/* ===== BR GALLERY FOLLOWS POLISH (16 Sep 2026) =====
   When the Polish selector changes on a product page, slide the gallery to that
   variant's image (if the variant has one). Backup: assets/br-backup-16sep2026-custom.js.txt */
$(document).ready(function(){
  var sel=document.querySelector('.single-option-selector'); var gal=$('.product_gallery .product_gallery_slider'); if(!sel||!gal.length) return;
  var prod=null; document.querySelectorAll('script[type="application/json"]').forEach(function(s){ if(prod) return; try{ var j=JSON.parse(s.textContent); if(j&&j.variants&&j.media) prod=j; }catch(e){} });
  if(!prod) return;
  sel.addEventListener('change', function(){
    var v=prod.variants.filter(function(x){ return x.option1===sel.value; })[0];
    var img=v&&v.featured_image; if(!img) return;
    var pos=-1; prod.media.forEach(function(m,i){ if(m.id===img.id||(m.src&&img.src&&m.src.split('?')[0]===img.src.split('?')[0])) pos=i; });
    if(pos<0 && img.position) pos=img.position-1;
    if(pos>=0 && gal.hasClass('slick-initialized')) gal.slick('slickGoTo', pos);
  });
});
/* ===== END BR GALLERY ===== */
